import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const themedSafeAreaTopStyles = StyleSheet.create({
	pageDefault: {
		flex: 1,
		backgroundColor: colorList.PAGE.primary
	},
	topDefault: {
		flex: 0,
		backgroundColor: colorList.WHITE.primary,
	}
})
